module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_c('p', {
    staticStyle: {
      "color": "#6C7A80"
    }
  }, [_vm._v("\n            ฐานข้อมูลเห็ดพิษ (ThaiMushroom.net) กรมวิทยาศาสตร์การแพทย์ ร่วมกับมหาวิทยาลัยมหาสารคาม ภาคีเครือข่ายนักวิชาการสาธารณสุขและภาคประชาชนร่วมจัดทำขึ้นเพื่อเป็นเครื่องมือคัดกรองเห็ดพิษแบบรวดเร็ว เพื่อการศึกษาและเตือนภัยประชาชนประกอบการตัดสินใจ\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dedd774","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoApp.vue
// module id = 1093
// module chunks = 1